import { ReservationModel } from '@/modules/reservation/reservation-model';

const { fields } = ReservationModel;

export default [
  fields.id,

  fields.createdAt
];
